
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forkliftestimates/terms-and-conditions",
      function () {
        return require("private-next-pages/forkliftestimates/terms-and-conditions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forkliftestimates/terms-and-conditions"])
      });
    }
  